import { useEffect } from 'react';
export function useAutocompleteAutoselection(options, onChange) {
    useEffect(() => {
        switch (options.length) {
            case 0:
                onChange?.(null);
                break;
            case 1:
                onChange?.(options[0]);
                break;
            default:
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options]);
}
